import gql from "graphql-tag";
import Constants from "../../Constants/Constants";

export const SUBSCRIBE_OUTSTANDING = gql`
  subscription outstanding($offset: Int!, $limit: Int!, $filter: String!){
    outstanding: CustomerCredit(where:{_and: [{_or: [{Customer: {name: {_ilike: $filter}}}, {Customer: {mobile: {_ilike: $filter}}} ]}]},
                    offset: $offset, limit: $limit, order_by: {created_at: desc}){
      id
      Customer { id name mobile profileImage}
      creditLimit
      availableCredit
      Orders_aggregate (where: {statusId: {_eq: "${Constants.OrderStatuses.Delivered}"}}) {aggregate {
        sum {payableAmount}
        count
      }}
      CreditDebit_aggregate(where: {type: {_eq: "CREDIT"}}) {
        aggregate {sum {amount}}
      }
   }
  }
`

export const SUBSCRIBE_OUTSTANDING_COUNT = gql`
  subscription outstandingCount($status:[uuid!], $filter: String!){
    outstandingCount: CustomerCredit_aggregate(where:{_and:[{_or: [{Customer: {name: {_ilike: $filter}}}, {Customer: {mobile: {_ilike: $filter}}} ]}]} ){
      aggregate { count }
    }
  }
`
export const SUBSCRIBE_OUTSTANDING_BY_ID = gql`
  query outstandingById($customerCreditId: uuid!){
    outstanding: CustomerCredit(where:{id: {_eq: $customerCreditId}}){
      id
      Customer { id name mobile email profileImage city }
      creditLimit
      availableCredit
      outstanding
      dueDayLimit
      Orders_aggregate (where: {statusId: {_eq: "${Constants.OrderStatuses.Delivered}"}}) {
       aggregate {sum {payableAmount}}
      }
      CreditDebit_aggregate(where: {type: {_eq: "CREDIT"}}) {aggregate {sum {amount}} }
      Orders (where: {statusId: {_eq: "${Constants.OrderStatuses.Delivered}"}}, order_by: {created_at: desc}){
         id 
         payableAmount
         orderType
         orderNumber
         created_at 
         Status{id status}
         CreditDebit_aggregate(where: {type: {_eq: "CREDIT"}}) { aggregate {sum {amount}}}
      }
   }
  }
`
